<template>
    <v-row no-gutters>
        <v-col>
            <v-card flat outlined class="my-1" :class="order.Id ? '' : 'potentialorder'">
                <v-card flat class="pa-3 hidecaret" color="transparent" :ripple="false"
                    @click.stop="collapsed = !collapsed">
                    <v-row no-gutters align="center">
                        <v-col cols="8">
                            {{ order.ContractName }}
                            <template v-if="order.HasUnpaidPaymentPlan">
                                <div><v-icon color="warning">mdi-alert</v-icon>The contract has prior periods that have
                                    not been invoiced yet.</div>
                            </template>
                        </v-col>
                        <v-col cols="3">{{ formatCurrencyTotal(sum) }}</v-col>
                        <v-col cols="1" class="d-flex justify-end">
                            <v-btn icon>
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
                <template v-if="!collapsed">
                    <v-divider></v-divider>
                    <v-row no-gutters style="background-color: rgb(0 0 0 / 1%);" class="px-3 pb-3">
                        <v-col>
                            <v-row no-gutters class="py-1 mt-1" style="border-bottom: 1px solid rgb(0 0 0 / 20%);">
                                <v-col cols="2">
                                    Date
                                </v-col>
                                <v-col cols="6">
                                    CustomerName
                                </v-col>
                                <v-col cols="2" class="d-flex justify-end">
                                    TotalAmountExclVat
                                </v-col>
                                <v-col cols="2" class="d-flex justify-end">

                                </v-col>
                            </v-row>
                            <v-row v-for="detail in order.Details" :key="detail.CustomerId" no-gutters class="py-1"
                                style="border-bottom: 1px solid rgb(0 0 0 / 6%);">
                                <v-col cols="2">
                                    {{ i18nFormatDate(detail.PaymentStartDate) }}
                                </v-col>
                                <v-col cols="6">
                                    {{ detail.CustomerName }}
                                </v-col>
                                <v-col cols="2" class="d-flex justify-end">
                                    {{ formatCurrencyTotal(detail.OrderSum) }}
                                </v-col>
                                <v-col cols="2" class="d-flex justify-end">
                                    <v-btn icon small v-if="detail.CreateOrder" @click="unlock(detail)" color="warning"
                                        :disabled="detail.IsWorking"><v-icon>mdi-lock-reset</v-icon></v-btn>
                                    <v-btn v-if="detail.OrderId" color="primary" outlined small
                                        @click="toClipboard(detail.OrderId.split('-').at(-1))">
                                        {{ detail.OrderId.split('-').at(-1) }}
                                        <v-icon small class="ml-1">mdi-content-copy</v-icon>
                                    </v-btn>
                                    <v-btn v-else small color="primary" @click.stop="generateOrder(detail)"
                                        :disabled="detail.IsLocked || detail.IsWorking || detail.CreateOrder">
                                        Generate
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </template>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
import ClientAPI from '@/api/ClientAPIMixin';

export default {
    name: 'NextOrderCard',
    props: {
        order: Object,
    },
    components: {},

    data() {
        return {
            collapsed: true,
        };
    },

    methods: {
        unlock(detail) {
            const paymentPlans = detail.PaymentPlans.map(pp => pp.Id);
            ClientAPI.methods.unlockPaymentPlanForOrderGeneration(paymentPlans).then(() => {
                detail.CreateOrder = false;
            });
        },
        generateOrder(detail) {
            const paymentPlanIds = detail.PaymentPlans.map(pp => pp.Id);
            ClientAPI.methods.generateContractOrdersFromPaymentPlans(paymentPlanIds)
        },
    },

    computed: {
        sum() {
            return this.order.Details
                .map(d => d.OrderSum)
                .reduce((a, b) => a + b, 0);
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped>
.hidecaret.v-card--link:before {
    background: none;
    background-color: transparent;
}

.potentialorder {
    border: 1px dashed #9e9e9e !important;
    background-color: rgba(255, 255, 255, 0.641);
}
</style>